import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classnames from 'classnames';

import ArticleCover from '../../components/ArticleCover';
import ArticleSlider from '../../components/ArticleSlider';
import TypesSlider from '../../components/TypesSlider';
import * as Utils from '../../utils';
import { DEFAULT_SLIDE_KEY } from '../../constants';

const Article = (props) => {
  const [articlesInitialSlide, setArticlesInitialSlide] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const isArticleCoverActive = currentSlide === 0;
  const settings = {
    infinite: false,
    afterChange: (i) => {
      setCurrentSlide(i);
    },
    arrows: false,
    draggable: false,
    swipe: false,
  };
  const sliderRef = useRef();
  const isTypesSlider = props?.slider === 'types';
  const isArticlesSlider = !isTypesSlider;
  const handleBack = () => {
    sliderRef.current.slickGoTo(0);
    setCurrentSlide(0);
    setArticlesInitialSlide(null);
    Utils.scroll(Utils.slugify(props?.title));
  };
  const handleClose = () => {
    sliderRef.current.slickGoTo(0);
    setCurrentSlide(0);
  };
  const handleOpen = () => {
    sliderRef.current.slickGoTo(1);
    Utils.scroll(Utils.slugify(props?.title));
  };
  const items = !isTypesSlider ? props.items : [{ title: props?.subtitle }];
  const isLocked = !isArticleCoverActive;
  const handleStorage = () => {
    const key = sessionStorage.getItem(DEFAULT_SLIDE_KEY);
    const [slideTitle, slideIndex, slideSection] = key?.split('|') || [];

    if (Utils.slugify(props?.title) === slideTitle && slideIndex !== null) {
      setArticlesInitialSlide(slideIndex);

      // TODO
      if (slideSection) {
        setTimeout(() => {
          Utils.scroll(key?.replace(/\|/g, '-'));
        }, 450);
      }
      // END TODO
    }
  };

  useEffect(() => {
    if (articlesInitialSlide !== null) {
      setCurrentSlide(1);
      handleOpen();
      sessionStorage.removeItem(DEFAULT_SLIDE_KEY);
    }
  }, [articlesInitialSlide]);

  useEffect(() => {
    window.addEventListener('storage', handleStorage);
  }, []);

  return (
    <div
      className={classnames('article', `article--item--${props?.index}`, {
        'article--locked': isLocked,
      })}
      id={Utils.slugify(props?.title)}
    >
      <Slider ref={sliderRef} {...settings}>
        <ArticleCover
          {...props}
          handleOpen={handleOpen}
          items={items}
          setArticlesInitialSlide={setArticlesInitialSlide}
          isActive={isArticleCoverActive}
        />
        {isArticlesSlider && (
          <ArticleSlider
            handleBack={handleBack}
            handleClose={handleClose}
            initialSlide={articlesInitialSlide}
            isActive={!isArticleCoverActive}
            {...props}
          />
        )}
        {isTypesSlider && (
          <TypesSlider {...props} handleClose={handleClose} isActive={!isArticleCoverActive} />
        )}
      </Slider>
    </div>
  );
};

Article.propTypes = {
  index: PropTypes.number,
  items: PropTypes.array,
  slide: PropTypes.string,
  slider: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default Article;
